import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '@/lib/axios';
import { WebTemplatePreview, DEFAULT_WEB_CONFIG, type WebConfig } from '@/components/red/WebTemplatePreview';

export function DrPerfilPage() {
  const { slug } = useParams<{ slug: string }>();
  const [medico, setMedico] = useState<any>(null);
  const [webConfig, setWebConfig] = useState<WebConfig>(DEFAULT_WEB_CONFIG);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!slug) return;
    api.get(`/api/public/medicos/${slug}`)
      .then(r => {
        const data = r.data;
        setMedico(data);
        if (data.perfilPublicoContenido) {
          try {
            const parsed = JSON.parse(data.perfilPublicoContenido);
            // Solo usar como webConfig si tiene la estructura esperada (no es diseño Unlayer viejo)
            if (parsed.colorAcento || parsed.tipografia) {
              setWebConfig({ ...DEFAULT_WEB_CONFIG, ...parsed });
            }
          } catch { /* config inválida, usar defaults */ }
        }
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-gray-500 text-sm">Cargando perfil...</p>
        </div>
      </div>
    );
  }

  if (error || !medico) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-gray-800 font-semibold text-lg mb-1">Perfil no encontrado</p>
          <p className="text-gray-500 text-sm">El médico que buscas no existe o no está disponible.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <WebTemplatePreview medico={medico} config={webConfig} />
    </div>
  );
}
